import React from "react";
import Product from "../components/product/Product";
import PlanterSelector from "../components/PlanterSelector";
import {ProductData} from "../providers/product/product-types";
import {PRODUCTS} from "../providers/product/product-config";
import Header from "../components/header/Header";
import {Footer} from "../components/footer/Footer";

const Creator = () => {
    const [product, setProduct] = React.useState<ProductData>(PRODUCTS[0]);

    return (
        <div className="bg-indigo-50">
            <Header/>
            <PlanterSelector plant={product} setPlant={setProduct} plants={PRODUCTS}/>
            <Product product={product}/>
            <Footer/>
        </div>
    );
}

export default Creator;